import React from 'react';
import { BlockLoaderWrapper } from './BlockLoader.style.ts';

const BlockLoader = (props) => (
  <BlockLoaderWrapper className="block-loader" {...props} />
);

export default BlockLoader;
